import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/api';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { Tag, Users } from '@phosphor-icons/react';

/** Promozioni attive nella zona del cliente, opzionalmente per prestazione. */
export const PromotionsNearby = ({ region, province, comune, location, serviceId, professionalId, title = 'Promozioni nella tua zona', compact = false }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const params = new URLSearchParams();
    if (location) params.set('location', location);
    else if (comune) params.set('comune', comune);
    else if (province) params.set('province', province);
    else if (region) params.set('region', region);
    if (serviceId) params.set('service_id', serviceId);
    if (professionalId) params.set('professional_id', professionalId);
    api.get(`/api/promotions?${params.toString()}`)
      .then((r) => setItems(r.data.items || []))
      .catch(() => setItems([]));
  }, [region, province, comune, location, serviceId, professionalId]);

  if (items.length === 0) return null;

  return (
    <div className="space-y-3" data-testid="promotions-nearby">
      <div className="flex items-center gap-2">
        <Tag size={18} weight="duotone" className="text-primary" />
        <p className="font-heading font-medium text-lg">{title}</p>
        <Badge className="bg-primary/10 text-primary">{items.length}</Badge>
      </div>
      <div className={compact ? 'space-y-2' : 'grid sm:grid-cols-2 gap-3'}>
        {items.map((p) => (
          <Card key={p.promotion_id} className="rounded-2xl p-4 border-l-4 border-l-accent" data-testid={`promo-item-${p.promotion_id}`}>
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <p className="font-medium text-sm truncate">{p.service_name}</p>
                <Link to={`/professional/${p.professional_id}`} className="text-xs text-primary hover:underline" data-testid={`promo-pro-link-${p.promotion_id}`}>
                  {p.professional?.name} · {p.professional?.profession}
                </Link>
                <p className="text-[11px] text-foreground/60 mt-0.5">
                  {p.professional?.comune || p.professional?.province || p.professional?.region}
                </p>
              </div>
              <div className="text-right shrink-0">
                <p className="text-[11px] text-foreground/50 line-through">€{p.original_price.toFixed(2)}</p>
                <p className="font-heading font-bold text-xl text-primary">€{p.promo_price.toFixed(2)}</p>
                {p.discount_type === 'percent' && (
                  <Badge className="bg-emerald-100 text-emerald-800 text-[10px]">-{p.discount_value}%</Badge>
                )}
              </div>
            </div>
            <div className="flex items-center justify-between mt-3 pt-2 border-t border-border/60 text-[11px] text-foreground/65">
              <span className="flex items-center gap-1"><Users size={13} /> {p.slots_left} posti disponibili</span>
              <span>Entro il {new Date(p.end_date).toLocaleDateString('it-IT')}</span>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default PromotionsNearby;
